import { activateCompany } from "services";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { confirmationModalConfigs, ConfirmationModal } from "components/ActionModals/ConfirmationModal";
import { observer } from "mobx-react-lite";

export const CompanyActivateButton = observer(() => {
  const { companyCard, actionModals } = useStores();

  const activateCompanyHandler = async () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          buttonText={"Подтвердить"}
          calledQuery={() => activateCompany({ id: companyCard.card.id })}
          onSuccess={() => {
            setTimeout(() => companyCard.updateCardById(companyCard.card.id), 1500);
          }}
        />
      ),
      {
        ...confirmationModalConfigs,
        onClose: () => actionModals.closeAll(),
      }
    );
  };
  return (
    <CustomButton tooltip={"Статус компании сменится на: Активный"} onClick={activateCompanyHandler}>
      Активировать
    </CustomButton>
  );
});
